"use client";
import React, { useEffect, useState } from "react";
import FormAjax from "./FormAjax";
import {
  get_category,
  get_category_detail,
  get_type,
  get_type_detail,
} from "@/libs/general";
import { CategoriesType, TypesType } from "@/@types/response";
import { useFormContext } from "react-hook-form";
import { useWatch } from "react-hook-form";

const FormEligibilityAccount = (params: { onChange: (data: any) => void }) => {
  const {
    formState: { errors },
  } = useFormContext();

  const eligibility_category = useWatch({ name: "eligibility_category" }) || [];
  const eligibility_type = useWatch({ name: "eligibility_type" }) || [];

  return (
    <div className="grid lg:grid-cols-2 gap-4">
      <FormAjax
        label="Kategori Account"
        isMulti
        defaultValue={{
          dataKey: "category",
          value: eligibility_category! ?? [],
          getOptions: async (val?: string) => await get_category_detail(val!),
        }}
        name="eligibility_category"
        error={(errors.eligibility_category?.message! as any) || ""}
        getOptions={async (input) => await get_category("account", input)}
        dataKey="categories"
        labelKey="name"
        valueKey="name"
      />

      {eligibility_category?.length > 0 || eligibility_type?.length > 0 ? (
        <FormAjax
          label="Tipe Account"
          name="eligibility_type"
          isMulti
          defaultValue={{
            dataKey: "type",
            value: eligibility_type! ?? null,
            getOptions: async (val?: string) => await get_type_detail(val!),
          }}
          error={(errors.eligibility_type?.message! as any) || ""}
          getOptions={async (input) => {
            await get_type("account", input, eligibility_category?.join(","));
          }}
          dataKey="types"
          labelKey="name"
          valueKey="name"
          dependencies={eligibility_category}
        />
      ) : null}
    </div>
  );
};

export default FormEligibilityAccount;
